import React, { memo, useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { useLazyGetCompanyListQuery } from "../../../request/company";
import { selectCompanyAction } from "../../../store/Reducer";
import Translate from "../../../translation/utils/translateFunction";
import NoDataFound from "../../ManageTask/NoDataFound";

const CompanyListing = ({
  handleModal,
  showModal,
  selectedCompanyList = [],
  moduleType,
  setCompanyList,
  isSingleSelect = false,
  isFilter = false,
  onSelect,
}) => {
  const { search } = useLocation(); //add code if view task dependancy from webview
  const query = new URLSearchParams(search);
  const dispatch = useDispatch();
  const [allCompanyData, setAllCompanyData] = useState([]);
  const [checkedAll, setCheckedAll] = useState(false);
  const [checkedIdList, setCheckedIdList] = useState([...selectedCompanyList]);
  const [CompanyListData, setCompanyListData] = useState([]);
  useEffect(() => {
    setCheckedIdList([...selectedCompanyList]);
  }, [selectedCompanyList]);

  const handleClose = (clearAll) => {
    filter("");
    setCheckedIdList([...selectedCompanyList]);
    handleModal && handleModal(false);
  };

  const [getCompanyList, { data: companyResponse, isSuccess }] =
    useLazyGetCompanyListQuery();
  useEffect(() => {
    if (query?.get("token")) {
      fetch(query.get("url") + "company/companylist", {
        method: "GET",
        headers: {
          token: query.get("token"),
          "Content-Type": "application/json",
          timezone: query.get("timezone"),
        },
      })
        .then((res) => res.json())
        .then((res) => {
          setCompanyListData(res?.data);
        })
        .catch((err) => {});
    } else {
      getCompanyList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search]);
  useEffect(() => {
    if (isSuccess && companyResponse?.length) {
      setCompanyListData(companyResponse);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuccess]);
  useEffect(() => {
    if (allCompanyData?.length === selectedCompanyList?.length) {
      setCheckedAll(true);
    } else {
      setCheckedAll(false);
    }
  }, [selectedCompanyList, allCompanyData]);

  // ******************************** Company-Listing*********************************************
  useEffect(() => {
    if (CompanyListData?.length > 0) {
      CompanyListData?.length === selectedCompanyList.length &&
        setCheckedAll(true);
    }
    setCompanyResponse();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [CompanyListData]);

  const setCompanyResponse = (
    companyResponseTemp = [],
    isFromSearch = false
  ) => {
    setAllCompanyData([]);
    let companyData = [];
    isFromSearch
      ? companyResponseTemp.length > 0 &&
        companyResponseTemp.map((item) =>
          companyData.push({
            label: item.name,
            value: `${item._id}`,
          })
        )
      : CompanyListData?.map((item) =>
          companyData.push({
            label: item.name,
            value: `${item._id}`,
          })
        );
    setAllCompanyData(companyData);

    if (moduleType === "VENDOR") setCompanyList(companyData);
  };

  const filter = (searcValue) => {
    if (searcValue === "") setCompanyResponse();
    else {
      const currentFilterData = CompanyListData?.filter((item) =>
        item.name.toLowerCase().includes(searcValue.toLowerCase())
      );
      setCompanyResponse(currentFilterData, true);
    }
  };

  // *************************************SelectAll Checkbox***********************************
  const selectAll = (value) => {
    setCheckedAll(value);
    if (value) {
      CompanyListData?.map(
        (item) =>
          (checkedIdList.length <= 0 || checkedIdList[0].value !== item._id) &&
          checkedIdList.push({
            label: item.name,
            value: item._id,
          })
      );
      setCheckedIdList([...checkedIdList]);
    } else
      setCheckedIdList(
        CompanyListData?.length
          ? [
              {
                label: CompanyListData[0]?.name,
                value: CompanyListData[0]?._id,
              },
            ]
          : []
      );
  };

  const Checkbox = ({ item, onChangeInput, isChecked }) => {
    return (
      <>
        <div
          onClick={() => onChangeInput(item)}
          style={{ display: "inline-block" }}
        >
          <input
            type="checkbox"
            checked={isChecked}
            name={item.label}
            id={item.value}
            onChange={() => {}}
          />
          <label className="form-check-label">{item.label}</label>
        </div>
      </>
    );
  };

  const onChange = (item) => {
    if (checkedAll) {
      setCheckedAll(false);
      const tempArray = [];
      tempArray.push(item);
      setCheckedIdList([...tempArray]);
    } else {
      const isCheckedId =
        checkedIdList.length > 0
          ? checkedIdList.findIndex((idItem) => idItem.value === item.value)
          : -1;
      if (isCheckedId === -1) {
        const tempArray = [];
        tempArray.push(item);
        setCheckedIdList([...tempArray]);
      }
    }
  };

  return (
    <>
      <Modal
        show={showModal}
        onHide={handleClose}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        backdrop="static"
        scrollable={true}
        className="col-span-3 col-md-12"
      >
        <Modal.Header closeButton>
          <Modal.Title> {Translate("selectCompany:head")}</Modal.Title>
        </Modal.Header>
        <div style={{ marginInline: "5%", marginTop: "3%" }}>
          <input
            type="text"
            className="form-control"
            placeholder={Translate("common:search")}
            name="s"
            onChange={(e) => {
              filter(e.target.value);
            }}
            autoComplete="off"
          />
        </div>
        <Modal.Body
          style={{
            minHeight: "calc(100vh - 400px)",
            maxHeight: "calc(100vh - 400px)",
          }}
        >
          {allCompanyData?.length > 1 && !isSingleSelect && (
            <div
              className="modalStyling"
              // onClick={() => selectAll(!checkedAll)}
            >
              <input
                type="checkbox"
                onChange={() => selectAll(!checkedAll)}
                checked={checkedAll}
                style={{ marginRight: "0.5rem" }}
              />

              <label onClick={() => selectAll(!checkedAll)}>
                {Translate("selectCompany:selectAll")}
              </label>
            </div>
          )}
          <div
            className="table-responsive todo_list over-flow-md scrollBox"
            style={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            <table className="table table-hover table-striped table-vcenter mb-0">
              <tbody>
                {allCompanyData.length > 0 ? (
                  allCompanyData.map((item, index) => {
                    const isAvailable =
                      checkedIdList.length > 0 &&
                      checkedIdList.find(
                        (idItem) => idItem.value === item.value
                      );
                    const isChecked = isAvailable || false;
                    return (
                      <tr key={`${index}_${item.value}`}>
                        <td key={index} className="tdStyling">
                          <Checkbox
                            item={item}
                            onChangeInput={onChange}
                            isChecked={isChecked}
                          />
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <div className="NoDataDisplayStyling mt-4">
                    <tr>
                      <td className="displayNodata tdStyling">
                        <span>
                          <NoDataFound
                            message={Translate("manageTask:noCompany")}
                          />
                        </span>
                      </td>
                    </tr>
                  </div>
                )}
              </tbody>
            </table>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="btn btn-white addButton"
            onClick={() => {
              handleClose(true);
            }}
          >
            {Translate("common:close")}
          </Button>
          <Button
            variant={`primary saveButton`}
            // checkedIdList.length > 0 ? "" : "disabled"
            onClick={(event) => {
              if (checkedIdList.length > 0) {
                handleClose(false);
                isFilter
                  ? onSelect([...checkedIdList])
                  : dispatch(selectCompanyAction([...checkedIdList]));
              }
            }}
          >
            {Translate("common:save")}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
export default memo(CompanyListing);
